export const GENERAL_STEPS = 'GENERAL_STEPS'
export const VISIT_REQUEST_STEPS = 'VISIT_REQUEST_STEPS'
export const CANDIDACY_REQUEST_STEPS = 'CANDIDACY_REQUEST_STEPS'
export const TENANT_STEPS = 'TENANT_STEPS'
export const REJECTED_STEPS = 'REJECTED_STEPS'

// export enum EIntakeStep {
//   candidateVisitor = 1,
//   candidateTenant = 2,
//   tenant = 3,
//   notEligible = 4,
//   visitor = 5,
//   planAsVisitor = 6,
//   waitingList = 7,
// }

export const STEP_MAP = {
  GENERAL_STEPS: [0],
  VISIT_REQUEST_STEPS: [1, 5, 6, 7, 8],
  CANDIDACY_REQUEST_STEPS: [2],
  TENANT_STEPS: [3],
  REJECTED_STEPS: [4],
}

export const getCurrentStepType = step => Object.keys(STEP_MAP).find(type => STEP_MAP[type].includes(step))



// WEBPACK FOOTER //
// ./src/services/stepService.js